import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useCallback } from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickComponentCommonProps, pickAriaProps, pickDataProps } from '../../interfaces/commonProps';
import { FormHelperText } from '../FormHelperText';
import { FormLabel } from '../FormLabel';
import { StyledContainer, StyledToggleButton, StyledOnIndicator, StyledOffIndicator, StyledToggleContainer, StyledToggleSwitch, StyledLabelContainer, StyledFormLabelContainer } from './Toggle.styles';
export var Toggle = React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name,
      on = _ref.on,
      _ref$defaultOn = _ref.defaultOn,
      defaultOn = _ref$defaultOn === void 0 ? false : _ref$defaultOn,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      hint = _ref.hint,
      inputId = _ref.inputId,
      inputRef = _ref.inputRef,
      _ref$onChange = _ref.onChange,
      handleChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      labelledBy = _ref['aria-labelledby'],
      restProps = _objectWithoutProperties(_ref, ["id", "name", "on", "defaultOn", "disabled", "children", "hint", "inputId", "inputRef", "onChange", "aria-labelledby"]);

  var _useState = useState(defaultOn),
      _useState2 = _slicedToArray(_useState, 2),
      internalState = _useState2[0],
      setInternalState = _useState2[1];

  var state = on !== null && on !== void 0 ? on : internalState;
  var handleClick = useCallback(function (event) {
    handleChange(!state, event);

    if (on === undefined) {
      setInternalState(!internalState);
    }
  }, [handleChange, internalState, on, state]);
  return React.createElement(StyledContainer, _objectSpread({
    id: id,
    ref: ref,
    outerSpacing: useSpacing(restProps)
  }, pickComponentCommonProps(restProps), {}, pickAriaProps(restProps), {}, pickDataProps(restProps)), React.createElement(StyledToggleContainer, null, React.createElement(StyledToggleButton, {
    id: inputId,
    ref: inputRef,
    name: name,
    type: "button",
    role: "switch",
    disabled: disabled,
    "aria-labelledby": labelledBy,
    "aria-checked": state,
    onClick: handleClick
  }), React.createElement(StyledOnIndicator, null), React.createElement(StyledOffIndicator, null), React.createElement(StyledToggleSwitch, null)), (children || hint) && React.createElement(StyledLabelContainer, null, children && React.createElement(StyledFormLabelContainer, null, React.createElement(FormLabel, {
    variant: "static",
    disabled: disabled,
    htmlFor: inputId,
    required: true
  }, children)), hint && React.createElement(FormHelperText, {
    variant: "hint",
    disabled: disabled
  }, hint)));
});
Toggle.displayName = 'Toggle';